// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Unsafe_Reference from "../Unsafe.Reference/index.js";
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var bind = /* #__PURE__ */ Control_Bind.bind(Effect.bindEffect);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Specular_Dom_Builder.bindBuilder);
var newEvent = /* #__PURE__ */ Specular_FRP_Base.newEvent(Specular_Dom_Builder.monadEffectBuilder);
var monadFRP = /* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder);
var holdDyn = /* #__PURE__ */ Specular_FRP_Base.holdDyn(monadFRP);
var map1 = /* #__PURE__ */ Data_Functor.map(Specular_Dom_Builder.functorBuilder);
var map2 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorEvent);
var discard1 = /* #__PURE__ */ discard(Specular_Dom_Builder.bindBuilder);
var withDynamic_ = /* #__PURE__ */ Specular_FRP_Replaceable.withDynamic_(Specular_Dom_Builder.monadReplaceBuilder)(monadFRP);
var subscribeEvent_ = /* #__PURE__ */ Specular_FRP_Base.subscribeEvent_(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder);
var pure = /* #__PURE__ */ Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder);
var withUniqDynamic_ = function (dictMonadFRP) {
    var bind2 = Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1());
    var uniqDynBy = Specular_FRP_Base.uniqDynBy(dictMonadFRP);
    return function (dictMonadReplace) {
        var withDynamic_1 = Specular_FRP_Replaceable.withDynamic_(dictMonadReplace)(dictMonadFRP);
        return function (dictEq) {
            var eq = Data_Eq.eq(dictEq);
            return function (dyn) {
                return function (f) {
                    return bind2(uniqDynBy(eq)(dyn))(function (uniq) {
                        return withDynamic_1(uniq)(f);
                    });
                };
            };
        };
    };
};
var withRefUniqDynamic_ = function (dictMonadFRP) {
    var bind2 = Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1());
    var uniqDynBy = Specular_FRP_Base.uniqDynBy(dictMonadFRP);
    return function (dictMonadReplace) {
        var withDynamic_1 = Specular_FRP_Replaceable.withDynamic_(dictMonadReplace)(dictMonadFRP);
        return function (dyn) {
            return function (f) {
                return bind2(uniqDynBy(Unsafe_Reference.unsafeRefEq)(dyn))(function (uniq) {
                    return withDynamic_1(uniq)(f);
                });
            };
        };
    };
};
var whenD = function (dictMonadFRP) {
    var withUniqDynamic_1 = withUniqDynamic_(dictMonadFRP);
    var when = Control_Applicative.when(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0());
    return function (dictMonadReplace) {
        var withUniqDynamic_2 = withUniqDynamic_1(dictMonadReplace)(Data_Eq.eqBoolean);
        return function (dyn) {
            return function (block) {
                return withUniqDynamic_2(dyn)(function (b) {
                    return when(b)(block);
                });
            };
        };
    };
};
var unlessD = function (dictMonadFRP) {
    var withUniqDynamic_1 = withUniqDynamic_(dictMonadFRP);
    var unless = Control_Applicative.unless(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0());
    return function (dictMonadReplace) {
        var withUniqDynamic_2 = withUniqDynamic_1(dictMonadReplace)(Data_Eq.eqBoolean);
        return function (dyn) {
            return function (block) {
                return withUniqDynamic_2(dyn)(function (b) {
                    return unless(b)(block);
                });
            };
        };
    };
};
var sample = function (dictMonadFRP) {
    var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
    var Bind1 = (MonadCleanup1.Monad0()).Bind1();
    var bind2 = Control_Bind.bind(Bind1);
    var MonadEffect0 = dictMonadFRP.MonadEffect0();
    var liftEffect = Effect_Class.liftEffect(MonadEffect0);
    var newEvent1 = Specular_FRP_Base.newEvent(MonadEffect0);
    var discard2 = discard(Bind1);
    var subscribeEvent_1 = Specular_FRP_Base.subscribeEvent_(MonadEffect0)(MonadCleanup1);
    var holdDyn1 = Specular_FRP_Base.holdDyn(dictMonadFRP);
    return function (read) {
        return function (event) {
            return bind2(liftEffect(read))(function (initial) {
                return bind2(newEvent1)(function (update) {
                    return discard2(subscribeEvent_1(function (v) {
                        return bind(read)(update.fire);
                    })(event))(function () {
                        return holdDyn1(initial)(update.event);
                    });
                });
            });
        };
    };
};
var nextJust = function (dictMonadFRP) {
    var bind2 = Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1());
    var readDynamic = Specular_FRP_Base.readDynamic(dictMonadFRP.MonadEffect0());
    var foldDynMaybe = Specular_FRP_Base.foldDynMaybe(dictMonadFRP);
    return function (dyn) {
        return bind2(readDynamic(dyn))(function (currentValue) {
            return foldDynMaybe(function ($$new) {
                return function (old) {
                    if (old instanceof Data_Maybe.Just) {
                        return Data_Maybe.Nothing.value;
                    };
                    if (old instanceof Data_Maybe.Nothing && $$new instanceof Data_Maybe.Just) {
                        return new Data_Maybe.Just(new Data_Maybe.Just($$new.value0));
                    };
                    if (old instanceof Data_Maybe.Nothing && $$new instanceof Data_Maybe.Nothing) {
                        return Data_Maybe.Nothing.value;
                    };
                    throw new Error("Failed pattern match at Specular.FRP.Extra (line 89, column 9 - line 92, column 38): " + [ old.constructor.name, $$new.constructor.name ]);
                };
            })(currentValue)(Specular_FRP_Base.changed(dyn));
        });
    };
};
var forDyn_ = function (dictMonadReplace) {
    var dynamic_ = Specular_FRP_Replaceable.dynamic_(dictMonadReplace);
    return function (dictMonadFRP) {
        var dynamic_1 = dynamic_(dictMonadFRP);
        var traverse_ = Data_Foldable.traverse_(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0());
        return function (dictFoldable) {
            var traverse_1 = traverse_(dictFoldable);
            return function (dyn) {
                return function (f) {
                    return dynamic_1(map(traverse_1(f))(dyn));
                };
            };
        };
    };
};
var chain = function (first) {
    return function (second) {
        var fromRightM = function (v) {
            if (v instanceof Data_Either.Left) {
                return Data_Maybe.Nothing.value;
            };
            if (v instanceof Data_Either.Right) {
                return new Data_Maybe.Just(v.value0);
            };
            throw new Error("Failed pattern match at Specular.FRP.Extra (line 67, column 3 - line 67, column 50): " + [ v.constructor.name ]);
        };
        var fromLeftM = function (v) {
            if (v instanceof Data_Either.Left) {
                return new Data_Maybe.Just(v.value0);
            };
            if (v instanceof Data_Either.Right) {
                return Data_Maybe.Nothing.value;
            };
            throw new Error("Failed pattern match at Specular.FRP.Extra (line 63, column 3 - line 63, column 49): " + [ v.constructor.name ]);
        };
        return bind1(newEvent)(function (event) {
            return bind1(holdDyn(map1(map2(Data_Either.Left.create))(first))(map2((function () {
                var $100 = map1(map2(Data_Either.Right.create));
                return function ($101) {
                    return $100(second($101));
                };
            })())(Specular_FRP_Base.filterMapEvent(fromLeftM)(event.event))))(function (v) {
                return discard1(withDynamic_(v)(function (widget) {
                    return bind1(widget)(function (e) {
                        return subscribeEvent_(event.fire)(e);
                    });
                }))(function () {
                    return pure(Specular_FRP_Base.filterMapEvent(fromRightM)(event.event));
                });
            });
        });
    };
};
export {
    forDyn_,
    whenD,
    unlessD,
    chain,
    sample,
    nextJust,
    withUniqDynamic_,
    withRefUniqDynamic_
};
